import axiosNew from '../../../../helpers/axios'

export const getProjectHealthReport = async (projectId) => {
    const id = String(projectId || '').trim()
    return new Promise(async (resolve) => {
        try {
            const response = await axiosNew({
                url: `support/reports/health/${id}`,
                method: 'GET',
            })
            const body = response?.data ?? {}
            resolve({
                success: body?.success ?? true,
                message: body?.message,
                result: body?.result ?? body?.data ?? null,
            })
        } catch (error) {
            resolve({
                success: false,
                message:
                    error?.response?.data?.message ??
                    'Failed to load project health report',
                result: null,
            })
        }
    })
}
